import { ReactNode } from 'react'

import { clsx } from 'clsx'

import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

interface Props {
  label: React.ReactNode
  onClick: () => void
  icon?: React.ReactNode
  className?: string
  disabled?: boolean
  tooltip?: ReactNode
}

export const ActionItem = ({
  label,
  onClick,
  icon,
  className,
  disabled,
  tooltip,
}: Props) => {
  return (
    <div className={className}>
      <div
        className={clsx(
          'font-medium hover:bg-surface-hovered p-2 rounded-base flex items-center gap-2 cursor-pointer text-sm transition-colors duration-300',
          disabled && 'opacity-60',
        )}
        onClick={disabled ? undefined : onClick}
      >
        {icon}
        {label}
        {disabled && (
          <Tooltip>
            <Tooltip.Trigger>
              <SvgIcon name="info" />
            </Tooltip.Trigger>
            <Tooltip.Panel>{tooltip}</Tooltip.Panel>
          </Tooltip>
        )}
      </div>
    </div>
  )
}
